import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { AtlassianAccountResponse, UserSegmentationData } from '../../common/types.tsx';

const GET_ME_URL = '/gateway/api/me';

export const getAtlassianAccount = (): Promise<AtlassianAccountResponse> =>
	performGetRequest(GET_ME_URL);

export const getUserSegmentationData = async (): Promise<UserSegmentationData> => {
	let response = {
		jobTitle: undefined,
		team: undefined,
	};

	try {
		const { extended_profile: extendedProfile } = await getAtlassianAccount();
		const { job_title: jobTitle, team_type: team } = extendedProfile;

		response = {
			// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
			jobTitle,
			// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
			team,
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// failed to fetch user segmentation data, analytics will be added later
		fireErrorAnalytics({
			meta: {
				id: 'getUserSegmentationData',
				packageName: 'jiraAtlassianNavigation',
				teamName: 'navigation',
			},
			error,
		});
	}

	return response;
};
